import { bem, QUALITY_LIMITATION_REASON } from '@socialive/common';
import interpolate from 'color-interpolate';
import PropTypes from 'prop-types';
import { useMemo } from 'react';
import HealthIndicatorIcon from './HealthIndicatorIcon';

import './healthIndicator.css';

/*
#tailwind
healthIndicator healthIndicator--primary healthIndicator--secondary
healthIndicator__icon healthIndicator__icon--none healthIndicator__icon--bandwidth
healthIndicator__icon--cpu
*/

const colormap = interpolate(['#DB5461', '#DB5461', '#F4A774', '#FFD952', '#BEF097', '#4ECE76']);

const HealthIndicator = ({ networkQuality, text, display, mode, limitation, className, ...other }) => {
  const color = useMemo(
    () => (networkQuality === undefined ? '#F4F5EF' : colormap(Math.ceil(networkQuality / 0.2) * 0.2)),
    [networkQuality]
  );

  return (
    <button type="button" className={bem`healthIndicator--${{ [mode]: true }} ${className}`} {...other}>
      <div className={bem`healthIndicator__icon--${{ [limitation]: true }}`} style={{ color }}>
        {(networkQuality > 0 || networkQuality === undefined) &&
          display === 'icon' &&
          limitation === QUALITY_LIMITATION_REASON.NONE && <HealthIndicatorIcon icon="dot" />}
        {(networkQuality > 0 || networkQuality === undefined) &&
          display === 'icon' &&
          limitation === QUALITY_LIMITATION_REASON.BANDWIDTH && <HealthIndicatorIcon icon="bandwidth" />}
        {(networkQuality > 0 || networkQuality === undefined) &&
          display === 'icon' &&
          limitation === QUALITY_LIMITATION_REASON.CPU && <HealthIndicatorIcon icon="cpu" />}
      </div>
      <div className="healthIndicator__icon--noConnection" style={{ color }}>
        {networkQuality <= 0 && display === 'icon' && <HealthIndicatorIcon icon="connectionError" />}
      </div>
      {display === 'text' && (
        <div className="healthIndicator__text" style={{ color }}>
          {text}
        </div>
      )}
    </button>
  );
};

HealthIndicator.propTypes = {
  text: PropTypes.string,
  networkQuality: PropTypes.number,
  mode: PropTypes.oneOf(['primary', 'secondary']),
  limitation: PropTypes.oneOf(Object.values(QUALITY_LIMITATION_REASON)),
  display: PropTypes.oneOf(['icon', 'text']),
  className: PropTypes.string,
};

HealthIndicator.defaultProps = {
  text: undefined,
  networkQuality: undefined,
  mode: 'primary',
  limitation: QUALITY_LIMITATION_REASON.NONE,
  display: 'icon',
  className: undefined,
};

export default HealthIndicator;
